<ng-container *ngIf="invoiceDocuments$ | async as documents">
  <prlw-uploaded-documents-ui
    [documents]="documents"
    (sendDocument)="sendDocument($event)"
  ></prlw-uploaded-documents-ui>
</ng-container>
